import { Area, AreaChart, Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { ChartTip, nb } from "@/components/admin/stats/StatsBits";

const ROWS = [{ key: "views", label: "Sidevisingar" }, { key: "visitors", label: "Besøkande" }];
const TICK = { fill: "hsl(var(--muted-foreground))", fontSize: 11 };

/** The main traffic chart: page views as a soft sol area, unique visitors as an ink line beneath. */
export const TrafficChart = ({ series = [], height = 260 }) => {
  const empty = series.every((d) => !d.views);
  const n = series.length;
  const interval = n > 60 ? Math.ceil(n / 12) - 1 : n > 14 ? Math.ceil(n / 10) - 1 : 0;
  return (
    <div className="relative w-full min-w-0" style={{ height }} data-testid="stats-traffic-chart">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={series} margin={{ top: 10, right: 8, left: -18, bottom: 0 }}>
          <defs>
            <linearGradient id="grad-views" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="hsl(var(--sol))" stopOpacity={0.35} /><stop offset="100%" stopColor="hsl(var(--sol))" stopOpacity={0} /></linearGradient>
            <linearGradient id="grad-visitors" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="hsl(var(--foreground))" stopOpacity={0.14} /><stop offset="100%" stopColor="hsl(var(--foreground))" stopOpacity={0} /></linearGradient>
          </defs>
          <CartesianGrid vertical={false} stroke="hsl(var(--border))" strokeDasharray="3 3" />
          <XAxis dataKey="label" tickLine={false} axisLine={false} tick={TICK} dy={6} interval={interval} />
          <YAxis allowDecimals={false} tickLine={false} axisLine={false} tick={TICK} width={40} />
          <Tooltip content={<ChartTip rows={ROWS} />} cursor={{ stroke: "hsl(var(--foreground) / 0.2)" }} />
          <Area type="monotone" dataKey="views" stroke="hsl(var(--sol))" strokeWidth={2} fill="url(#grad-views)" dot={false} activeDot={{ r: 4, strokeWidth: 0 }} animationDuration={700} />
          <Area type="monotone" dataKey="visitors" stroke="hsl(var(--foreground))" strokeWidth={1.5} fill="url(#grad-visitors)" dot={false} activeDot={{ r: 4, strokeWidth: 0 }} animationDuration={700} />
        </AreaChart>
      </ResponsiveContainer>
      {empty && <p className="pointer-events-none absolute inset-0 flex items-center justify-center px-6 text-center text-sm text-muted-foreground">Ingen besøk registrerte i perioden enno – tala kjem etter kvart som folk brukar nettsida.</p>}
    </div>
  );
};

/** Small bar chart for one numeric series (bookings, tickets, revenue …). */
export const MiniBars = ({ series = [], dataKey, label, colour = "hsl(var(--sol))", height = 120, fmt, testId }) => {
  const n = series.length;
  const interval = n > 60 ? Math.ceil(n / 8) - 1 : n > 14 ? Math.ceil(n / 7) - 1 : 0;
  const empty = series.every((d) => !d[dataKey]);
  return (
    <div className="relative w-full min-w-0" style={{ height }} data-testid={testId}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={series} margin={{ top: 6, right: 4, left: -24, bottom: 0 }} barCategoryGap={n > 31 ? 1 : 3}>
          <XAxis dataKey="label" tickLine={false} axisLine={false} tick={TICK} dy={4} interval={interval} />
          <YAxis allowDecimals={false} tickLine={false} axisLine={false} tick={TICK} width={40} tickFormatter={(v) => (fmt ? fmt(v) : nb(v))} />
          <Tooltip content={<ChartTip rows={[{ key: dataKey, label, fmt }]} />} cursor={{ fill: "hsl(var(--foreground) / 0.05)" }} />
          <Bar dataKey={dataKey} fill={colour} radius={[3, 3, 0, 0]} animationDuration={600} />
        </BarChart>
      </ResponsiveContainer>
      {empty && <p className="pointer-events-none absolute inset-0 flex items-center justify-center text-[12.5px] text-muted-foreground">Ingenting i perioden</p>}
    </div>
  );
};
